import api from "./api";

interface RawGenre {
  name?: string;
}
type GenresResponse = RawGenre[] | { genres?: RawGenre[]; data?: RawGenre[] };

/** Genre NAMES (books store genres as plain name strings). */
export async function getGenres(): Promise<string[]> {
  const data = await api.get<unknown, GenresResponse>("/genres");
  const arr = Array.isArray(data) ? data : (data?.genres ?? data?.data ?? []);
  return arr
    .map((g) => g?.name)
    .filter((n): n is string => Boolean(n))
    .sort((a, b) => a.localeCompare(b));
}
